import { render } from "./CreateLogo.vue?vue&type=template&id=417e10bc"
import script from "./CreateLogo.vue?vue&type=script&lang=js"
export * from "./CreateLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__